/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { translate } from '../../../../common/translation/translate';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../../../common/utilities/sizeHelpers';
import { FooterDeviceStoreItem } from './footerDeviceStoreItem';
import { footerDeviceStores } from '../../../../common/translation/translate';
import { LazyLoadImg } from '../../../../common/utilities/lazyLoadImg';

export const FooterDevicesSection = memo(() =>
{
    return (
        <FooterDevicesWrapper >
            <WbFooterLogoContainer>
                <LazyLoadImg style={WbFooterLogoImageStyle}
                    alt='WeatherBug logo'
                    src='/images/mark.new.colored.svg'
                />
            </WbFooterLogoContainer>
            <FooterDevicesMsg>
                {translate('footerDevicesMessage')}
            </FooterDevicesMsg>
            <FooterDeviceStores>
                {
                    footerDeviceStores?.map(store => {
                        return (
                            <FooterDeviceStoreItem
                                key={store.storeLink}
                                deviceLink={store.storeLink}
                                deviceImage={store.storeImageSrc}
                                storeAriaLabel={store.storeAriaLabel}
                            />
                        );
                    })
                }
            </FooterDeviceStores>
        </FooterDevicesWrapper>
    );
});

FooterDevicesSection.DisplayName = 'FooterDevicesSection';

const WbFooterLogoImageStyle = {
    display: 'flex',
    width: 75,
    height: 79
};

const FooterDevicesWrapper = styled.section`
    display: flex;
    flex-direction: column;
    padding-top: 60px;
    position: relative;
    background-color: #ffffff;
    text-align: center;
    @media ${smallMediaQuery} {
        padding-top: 44px;
    }
`;

const WbFooterLogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;
`;

const FooterDevicesMsg = styled.span`
    position: relative;
    margin-bottom: 34px;
    margin-top: 20px;
    font-size: 23px;
    font-weight: 400;
    line-height: 1.25;
    color: #435560;
    @media ${largeMediaQuery} {
        font-size: 34px;
    }
    @media ${mediumMediaQuery} {
        margin-bottom: 40px;
        margin-top: 20px;
        font-size: 28px;
    }
`;

const FooterDeviceStores = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    position: relative;
    font-size: 0;
    align-items: center;
    width: 100%;
    justify-content: center;
    @media ${smallMediaQuery} {
        grid-template-columns: 1fr;
        align-items: center;
    }
`;
